import Vue from 'vue'
import { CONFIRMATION_REDIRECT_TIME } from '@/base/const/confirmation.const'

export default {
  data () {
    return {
      redirectHandler: null,
      redirectTime: Vue.prototype.$VUE_CONFIRMATION_TIMER ? Vue.prototype.$VUE_CONFIRMATION_TIMER : CONFIRMATION_REDIRECT_TIME,
      timerPausedByInteraction: false
    }
  },
  methods: {
    stopRedirectTimeout () {
      if (this.redirectHandler) {
        clearTimeout(this.redirectHandler)
      }
    },
    startRedirectTimeout () {
      if (this.timerPausedByInteraction) return
      this.redirectHandler = setTimeout(this.checkRedirectTimeout, 1000)
    },
    checkRedirectTimeout () {
      if (this.redirectTime === 1) {
        this.goBackToShop()
        return
      }
      this.redirectTime--
      this.startRedirectTimeout()
    },
    pauseTimerOnInteraction () {
      this.timerPausedByInteraction = true
      this.announceToScreenReader(this.$t('confirmation.linkBackTimerStopped'))
      this.stopRedirectTimeout()
      this.removeInteractionListeners()
    },
    addInteractionListeners () {
      ['keydown', 'click', 'touchstart'].forEach(eventName => {
        const handler = (event) => {
          if (!event.isTrusted) return
          this.pauseTimerOnInteraction()
        }
        document.addEventListener(eventName, handler)
        this._interactionHandlers = this._interactionHandlers || []
        this._interactionHandlers.push({ eventName, handler })
      })
    },
    removeInteractionListeners () {
      if (this._interactionHandlers) {
        this._interactionHandlers.forEach(({ eventName, handler }) => {
          document.removeEventListener(eventName, handler)
        })
        this._interactionHandlers = null
      }
    },
    attachSurveyListeners (survey) {
      survey.addEventListener('mouseenter', () => {
        this.pauseTimerOnInteraction()
      }, { once: true })
    },
    observeSurveyElement () {
      const survey = document.getElementById('yourcx.insert')
      if (survey) {
        this.attachSurveyListeners(survey)
        return
      }
      this._surveyObserver = new MutationObserver(() => {
        const el = document.getElementById('yourcx.insert')
        if (el) {
          this.attachSurveyListeners(el)
          this._surveyObserver.disconnect()
          this._surveyObserver = null
        }
      })
      this._surveyObserver.observe(document.body, { childList: true, subtree: true })
    },
    announceToScreenReader (message) {
      const existing = document.getElementById('sr-redirect-alert')
      if (existing) existing.remove()
      const alert = document.createElement('div')
      alert.id = 'sr-redirect-alert'
      alert.setAttribute('role', 'alert')
      alert.setAttribute('aria-atomic', 'true')
      alert.className = 'sr-only'
      document.body.appendChild(alert)
      setTimeout(() => {
        alert.textContent = message
      }, 100)
    },
    removeScreenReaderAlert () {
      const existing = document.getElementById('sr-redirect-alert')
      if (existing) existing.remove()
    },
    initRedirectTimer () {
      this.startRedirectTimeout()
      this.addInteractionListeners()
      this.observeSurveyElement()
      setTimeout(() => {
        if (!this.timerPausedByInteraction) {
          const statusEl = document.querySelector('#page-title-for-sr span:not(.sr-only)')
          const statusText = statusEl ? statusEl.textContent.trim() : ''
          const redirectMessage = this.$t('confirmation.linkBackAutoRedirect', { time: this.redirectTime })
          this.announceToScreenReader(statusText ? statusText + '. ' + redirectMessage : redirectMessage)
        }
      }, 2000)
      this.$refs['backButton'].addEventListener('focus', () => {
        this.stopRedirectTimeout()
      })
    },
    destroyRedirectTimer () {
      this.stopRedirectTimeout()
      this.removeInteractionListeners()
      this.removeScreenReaderAlert()
      if (this._surveyObserver) {
        this._surveyObserver.disconnect()
        this._surveyObserver = null
      }
    }
  }
}
